function getOffset(el) {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY,
    width: rect.width,
  };
}

export default {
  inserted: (el, _binding, vnode) => {
    let selectIsOpen = false;

    const applyPositioning = () => {
      const { offsetWidth, offsetHeight } = el;
      const targetElement = Array.from(el.childNodes).find(child => child.classList && child.classList.contains('multiselect__content-wrapper'));
      if (targetElement) {
        const targetElementWidth = targetElement.offsetWidth;
        targetElement.style.position = 'fixed';
        targetElement.style.left = `${getOffset(el).left + offsetWidth - targetElementWidth}px`;
        targetElement.style.top = `${getOffset(el).top + offsetHeight}px`;
        targetElement.style.maxWidth = `${getOffset(el).width}px`;
        targetElement.style.minHeight = '10px';
      }
    };

    vnode.child.$watch('isOpen', (isOpen) => {
      selectIsOpen = isOpen;
      if (isOpen) {
        applyPositioning();
      }
    });

    window.addEventListener(
      'scroll',
      () => {
        if (selectIsOpen) {
          applyPositioning();
        }
      },
      true,
    );
  },
};
